import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { Form, Formik } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { FormikTextField } from 'src/app/components/Form/FormikTextField/FormikTextField';
import { Step } from 'src/app/components/Pages/GetStartedNew/StepLayout/Step';
import { useZipCodeDeliverabilityCheck } from 'src/app/hooks/data/zipCode';
import { useGetStartedPersistentData } from 'src/app/hooks/feature_data/useGetStartedPersistentData';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import { getStartedNewContact, getStartedNewWaitlist, home } from 'src/app/router/paths';

import { ButtonContainer, StyledButton } from '../../styles';

export const Welcome = () => {
  useSegmentTrack(UNIFIED.viewOnboardingDeliveryAreaEligibilityForm);
  const { push } = useHistory();
  const { replace } = useRouter();

  const [label, setLabel] = useState('Zip code');

  const [zipCode, setZipCode] = useState('');
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);

  const { data: isZipCodeDeliverable, isError: isZipCodeDeliverableError } = useZipCodeDeliverabilityCheck(zipCode, {
    enabled: isSubmitPressed && zipCode.length === 5,
  });

  const { setGetStartedPersistentData } = useGetStartedPersistentData();

  useEffect(() => {
    if (isSubmitPressed && isZipCodeDeliverable?.isDeliverable !== undefined) {
      setIsSubmitPressed(false);

      setGetStartedPersistentData({ zipCode, email: '' });

      if (isZipCodeDeliverable.isDeliverable) {
        push(getStartedNewContact.route);
      } else {
        push(getStartedNewWaitlist.route);
      }
    }

    if (isZipCodeDeliverableError) {
      setIsSubmitPressed(false);
    }
  }, [isZipCodeDeliverable, isZipCodeDeliverableError, push, isSubmitPressed, setGetStartedPersistentData, zipCode]);

  return (
    <Step
      handlePrev={() => replace(home.toPath())}
      title={`Check if we deliver to you`}
      text={`We're the smarter, simpler, kinder pharmacy. To get started, let's check your delivery zip.`}
    >
      <Formik
        initialValues={{ zipCode: '' }}
        validationSchema={Yup.object().shape({
          zipCode: Yup.string().required().label('Zip code'),
        })}
        onSubmit={() => setIsSubmitPressed(true)}
      >
        <Form>
          <FormikTextField
            type="text"
            value={zipCode}
            name="zipCode"
            label={{
              content: label,
              isHidden: false,
            }}
            onChange={e => {
              setIsSubmitPressed(false);
              if (e.target.value === '' || (e.target.value.length < 6 && e.target.value.match(/^[0-9]+$/))) {
                setZipCode(e.target.value);
              }
            }}
            onFocus={() => setLabel('Zip code')}
            onBlur={e => {
              if (e.target.value === '') {
                setLabel('Zip code (e.g. home or work)');
              }
            }}
          />
          <ButtonContainer smallMarginTop={true}>
            <StyledButton
              size="medium"
              disabled={isSubmitPressed || zipCode.length < 5}
              onClick={() => setIsSubmitPressed(true)}
              type="submit"
              style={'capsuleBlue50'}
            >
              Continue
            </StyledButton>
          </ButtonContainer>
        </Form>
      </Formik>
    </Step>
  );
};
